import { Modal } from "antd";
import { ReactNode, useState } from "react";
import { STATUS_REQUESTED } from "../../../constants/constants";

interface Props {
    open: boolean;
    onCancel: () => void;
    onOk: () => void;
    content: ReactNode
    okText?: string;
    cancelText?: string;
    danger?: boolean
}
const ConfirmModal = (props: Props) => {
    const { open, content, okText } = props;

    const [submitLoading, setSubmitLoading] = useState(false);
    const onOk = () => {
        props.onOk()
    }
    return (
        <Modal
            width={300}
            open={open}
            onCancel={() => props?.onCancel()}
            onOk={() => onOk()}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0",
                body: "!p-[20px]",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            title={(
                <p className="m-0 font-[500]">
                    Alert
                </p>
            )}
            okText={okText || `Ok`}
            okButtonProps={{
                danger: props?.danger,
                loading: submitLoading
            }}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
        >
            {content}
        </Modal>
    )
}

export default ConfirmModal